module.exports = __webpack_public_path__ + "img/vertical_4_7_9005.89176153.png";